import React from "react"
import { graphql, Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck } from "@fortawesome/free-solid-svg-icons"

import Layout from "../components/layout"
import Seo from "../components/seo"
import Menu from "../components/menu"

class CategoryTemplate extends React.Component {
  render() {
    const { data, location } = this.props
    const { posts, category } = this.props.pageContext
    const siteTitle = data.site.siteMetadata.title

    return (
      <Layout location={location} title={siteTitle}>
        <Seo title={siteTitle} />
        <Menu location={location} />
        <article>
          <div
            style={{
              marginLeft: `auto`,
              marginRight: `auto`,
              height: 'auto',
              padding: `1em calc(33% - 6.6em)`,
              fontSize: `calc(.6vw + .8em)`,
            }}
          >
            <h2>
              <FontAwesomeIcon icon={faCheck} fixedWidth size="sm" />
              <span style={{ marginLeft: `.5em` }}>Category: {category}</span>
            </h2>

            <ul>
              {posts.map(post => (
                <li key={post.fields.slug}>
                  <Link
                    to={`${post.fields.slug}`}
                    style={{ color: `rgb(0, 122, 204)` }}
                  >
                    {post.frontmatter.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </article>
      </Layout>
    )
  }
}

export default CategoryTemplate

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        siteUrl
        social {
          twitter
        }
      }
    }
    allMarkdownRemark(sort: { frontmatter: { date: DESC }}) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            date(formatString: "YYYY-MM-DD")
            categories
          }
        }
      }
    }
  }
`
